import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.generated.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="julientassin.eu.auth0.com"
      clientId="S0cygqTdd7QhwzpfcakPsNMqiEFQ8qFs"
      authorizationParams={{
        redirect_uri: window.location.origin,
        // Demander un refresh token pour permettre la persistance de session
        scope: "read:current_user openid profile email offline_access",
        // Audience pour obtenir un access token JWT au lieu d'un ID token JWE
        audience: "https://julientassin.eu.auth0.com/api/v2/",
      }}

      // Stocker les informations dans localStorage plutôt que dans sessionStorage
      cacheLocation="localstorage"
      // Activer l'utilisation des refresh tokens pour maintenir la session
      useRefreshTokens={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);
